import React, { useState, useEffect } from 'react'
import {
	TitleTransferPoints,
	BoxTransferPoints,
	PointsCointainer,
	ImportantRules,
	RulesListItem,
	ContainerPoints,
	RulesList,
	Regulation,
	Column,
	Points,
	Item,
	Insuficient
} from './styles.style'

import { UpdateClientService } from '../../../private/client/information/services/update-client.service'
import { SelectInput } from '../../../../components/form-components/inputs.component.jsx'
import ModalConfirmation from '../../../../components/modal/modal-confirmation.component'
import { Creators as SiteCreators } from '../../../../ducks/site/site'
import { LiveloService } from '../../../../services/livelo.service'
import { clientActions, toastActions } from '../../../../actions'
import { maskHelper } from '../../../../helpers'
import { getPointsTransfer } from './points-options'
import { bindActionCreators } from 'redux'
import { Formik, Form } from 'formik'
import { connect } from 'react-redux'

const LiveloContent = ({ showLoading, hideLoading, client, toastDanger }) => {
	const [isModalOpen, setIsModalOpen] = useState(false)
	const [pointsToBuy, setPointsToBuy] = useState([])
	const [availablePointsToBuy] = useState(1000)
	const [muviflexPoints, setMuviflexPoints] = useState(0)
	const [liveloPoints, setLiveloPoints] = useState(0)
	const [load, setLoad] = useState(false)
	const [sumPointsLivelo, setSumPointsLivelo] = useState(0)
	const [sumPointsMuviflex, setSumPointsMuviflex] = useState(0)
	const [transferPoints, setTransferPoints] = useState(0)
	const [user, setUser] = useState([])

	function redirectUrl(url) {
		return (window.location.href = window.location.pathname + url)
	}

	useEffect(() => {
		showLoading()

		UpdateClientService.get().then(res => {
			setUser(res.personal)
		})

		LiveloService.searchParamethers().then(res => {
			const { muviflexPoints, liveloPoints } = res
			setMuviflexPoints(muviflexPoints)
			setLiveloPoints(liveloPoints)
			localStorage.removeItem('UserPointsTransfer')
			setLoad(true)
			hideLoading()
		})
	}, [])

	useEffect(() => {
		setPointsToBuy(getPointsTransfer(availablePointsToBuy))
	}, [availablePointsToBuy])

	function onResult(confirmed) {
		setIsModalOpen(false)

		if (confirmed) {
			showLoading()

			LiveloService.transferPoints(sumPointsMuviflex)
				.then(res => {
					if (res) {
						if (res.success) {
							localStorage.setItem(
								'UserPointsTransfer',
								JSON.stringify(res)
							)
							redirectUrl('/pedido-confirmado')
						} else {
							setTimeout(() => {
								toastDanger({ message: String(res.errors) })
								hideLoading()
							}, 500)
						}
					} else {
						toastDanger({
							message:
								'Não foi possível realizar transferência de pontos'
						})
						hideLoading()
					}
				})
				.catch(errors => {
					toastDanger({ message: String(errors) })
					hideLoading()
				})
		}
	}

	function openModal() {
		setIsModalOpen(true)
	}

	function onChangeSelectPointsQuantity(value) {
		showLoading()

		const { clientPointsWasLoaded, balancePoints } = client

		if (!value) return
		setSumPointsLivelo(value / muviflexPoints)
		setSumPointsMuviflex(value)

		if (clientPointsWasLoaded) {
			setTransferPoints(balancePoints - value)
		}
		hideLoading()
	}

	return load ? (
		<div>
			<Formik
				render={props => (
					<Form className="form" noValidate>
						<PointsCointainer>
							{muviflexPoints > 1 ? (
								<Points>{muviflexPoints} pontos Muviflex</Points>
							) : (
								<Points>{muviflexPoints} ponto Muviflex</Points>
							)}

							<Points className="equal">=</Points>

							{liveloPoints > 1 ? (
								<Points>{liveloPoints} pontos Livelo</Points>
							) : (
								<Points>{liveloPoints} ponto Livelo</Points>
							)}
						</PointsCointainer>
						<BoxTransferPoints>
							<TitleTransferPoints>
								Selecione a quantidade de pontos que deseja transferir
							</TitleTransferPoints>
							<ContainerPoints>
								<Column>
									<Item>
										<h5>Quantidade de pontos Muviflex</h5>
										<SelectInput
											defaultValue={{ value: '', label: '' }}
											onValueChange={onChangeSelectPointsQuantity}
											options={pointsToBuy}
											className={'select'}
											multi={false}
											id={'points'}
											{...props}
										/>
									</Item>
									<Item>
										<h5 className="center">
											Quantidade de pontos Livelo
										</h5>
										<em>
											{Number(sumPointsLivelo).toLocaleString(
												'pt-BR'
											)}{' '}
										</em>
									</Item>
									<Item>
										<h5 className="center">
											Saldo em pontos Muviflex após troca
										</h5>
										{transferPoints >= 0 ? (
											<div>
												<em>
													{Number(transferPoints).toLocaleString(
														'pt-BR'
													)}
												</em>
												<small>pontos</small>
											</div>
										) : (
											<Insuficient>Saldo insuficiente</Insuficient>
										)}
									</Item>
									<Item className="only">
										<button
											type="button"
											onClick={openModal}
											disabled={sumPointsMuviflex == 0}
											className={
												sumPointsMuviflex == 0 ? 'disabled' : ''
											}>
											Transferir pontos
										</button>
									</Item>
								</Column>
							</ContainerPoints>
							<Regulation>
								<ImportantRules>Regras Importantes</ImportantRules>
								<RulesList>
									<RulesListItem>
										Os participantes do Programa Muviflex podem
										transferir seus pontos Muviflex para a Livelo
										através do site{' '}
										<a
											href="www.muviflex.com.br"
											title="www.muviflex.com.br">
											www.muviflex.com.br
										</a>
										. Para isso, será necessário ser participante de
										ambos programas de fidelidade – ou que se
										cadastrarem na Livelo antes de solicitar a
										transferência de pontos.
									</RulesListItem>
									<RulesListItem>
										Os pontos Muviflex só poderão ser transferidos
										para a Livelo em lotes de 1.000 pontos Muviflex.
										Cada 5 pontos Muviflex equivalem a 1 ponto Livelo.
										Cada participante pode transferir no máximo 10mil
										pontos Muviflex para a Livelo por mês.
									</RulesListItem>
									<RulesListItem>
										As informações fornecidas pelos participantes na
										solicitação de transferência de pontos são de sua
										inteira responsabilidade, ocasionando o
										cancelamento da transferência caso forneçam
										informações insuficientes ou indevidas.
									</RulesListItem>
									<RulesListItem>
										Após a transferência concluída, os participantes
										poderão usar os pontos de acordo com as regras do
										programa de recompensas Livelo para usufruir das
										vantagens e benefícios do programa.
									</RulesListItem>
									<RulesListItem>
										O prazo para que a transferência dos pontos seja
										concluída são de até 30 dias corridos.
									</RulesListItem>
									<RulesListItem>
										Após a transferência concluída, não será possível
										o cancelamento ou estorno da solicitação.
									</RulesListItem>
								</RulesList>
							</Regulation>
							<ModalConfirmation
								onResult={onResult}
								isOpen={isModalOpen}
								title="Confirmação de transferência">
								<p>Você confirma a transferência de pontos?</p>
								<ul>
									<li>Nome: {user.name}</li>
									<li>CPF: {maskHelper.applyCpf(user.cpf)}</li>
									<li>
										Quantidade de pontos Muviflex:{' '}
										{Number(sumPointsMuviflex).toLocaleString(
											'pt-BR'
										)}
									</li>
									<li>
										Quantidade de pontos Livelo:{' '}
										{Number(sumPointsLivelo).toLocaleString('pt-BR')}
									</li>
								</ul>
							</ModalConfirmation>
						</BoxTransferPoints>
					</Form>
				)}
			/>
		</div>
	) : null
}

const mapStateToProps = ({ client }) => ({ client })

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
			getPointsInformation: clientActions.getPointsInformation,
			hideLoading: SiteCreators.hideLoading,
			showLoading: SiteCreators.showLoading,
			toastDanger: toastActions.danger
		},
		dispatch
	)

export default connect(mapStateToProps, mapDispatchToProps)(LiveloContent)
